import ActTable from './act-list';

interface DocumentListProps {
  onBack: () => void;
}

export default function DocumentList({ onBack }: DocumentListProps): React.ReactElement {
  return <ActTable onBack={onBack} />;
}

DocumentList.displayName = 'document list component';
